import { IntakeLabelCollection } from '../../entities/intake-label.interface';
import { MinistryList } from '../../constants/ministry-list';

export const IesConsentLabels: IntakeLabelCollection = {
  agreeCraConsent: {
    label: 'I have read and agree to the Canada Revenue Agency consent above.',
  },
  agreeCraConsentContent: {
    label: `I consent to the release, by Canada Revenue Agency to an official of Alberta ${MinistryList.scss.displayValue}, of information from my income tax returns and other taxpayer information about me whether supplied by me or a third party. The information will be relevant to, and will be used solely for the purpose of determining, verifying and/or auditing my/our eligibility and for the general administration and enforcement of programs under the <em>Income and Employment Supports Act</em>. This consent is valid for the taxation year prior to the year of signature, the current taxation year and for each subsequent taxation year for which assistance is requested.`,
  },
};
